import { render, staticRenderFns } from "./addexhibitionA.vue?vue&type=template&id=921034b0&scoped=true&"
import script from "./addexhibitionA.vue?vue&type=script&lang=js&"
export * from "./addexhibitionA.vue?vue&type=script&lang=js&"
import style0 from "./addexhibitionA.vue?vue&type=style&index=0&id=921034b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921034b0",
  null
  
)

export default component.exports